import Header from "./components/Header";
import Hero from "./components/Hero";
import HotList from "./components/HotList";
import ArchiveSection from "./components/ArchiveSection";
import LatestSection from "./components/LatestSection";
import FaqSection from "./components/FaqSection";
import AboutSection from "./components/AboutSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import ScrollTop from "./components/ScrollTop";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <HotList />
        <ArchiveSection />
        <LatestSection />
        <FaqSection />
        <AboutSection />
        <ContactSection />
      </main>
      <Footer />
      <ScrollTop />
    </div>
  );
}